var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1350",
    d: "M0-682.665H21v21H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40966",
    "data-name": "Group 40966",
    transform: "translate(9405 23048)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15550",
    "data-name": "Rectangle 15550",
    width: 24,
    height: 24,
    transform: "translate(-9405 -23048)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1344",
    transform: "translate(-9403.5 -23046.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1346"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1348",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1354",
    transform: "translate(13.617 10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1356",
    d: "M0-304.986v-9.68H3.281v9.68",
    transform: "translate(0 314.666)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1358",
    transform: "translate(10.336 13.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1360",
    d: "M0-201.6V-208H3.281",
    transform: "translate(0 207.999)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1362",
    transform: "translate(3.117 7.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1364",
    d: "M0,0H8.2",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1366",
    transform: "translate(3.117 10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1368",
    d: "M0,0H8.2",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1370",
    transform: "translate(3.117 13.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1372",
    d: "M-155.078,0H-160",
    transform: "translate(160)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1374",
    transform: "translate(7.055 7.219)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1376",
    d: "M-103.385-310.155h-3.281v3.117h13.125V-320h-3.281v3.281",
    transform: "translate(106.666 319.999)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1378",
    transform: "translate(0.82 0.82)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1380",
    d: "M-118.893-609.972h-2.133a1.641,1.641,0,0,1-1.641-1.641v-16.078a1.641,1.641,0,0,1,1.641-1.641h9.516a1.641,1.641,0,0,1,1.641,1.641v5.578",
    transform: "translate(122.666 629.332)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.440dd80365727dccbbb7aecf4adc2581.svg";
export { ForwardRef as ReactComponent };